export const SUBSCRIPTION_CUSTOMER_DELIVERY_DATES_ROOT_PATH = "/customer";

/** /customer/getPossibleDeliveryDatesSub */
export const SUBSCRIPTIONS_CUSTOMER_GET_POSSIBLE_DELIVERY_DATES_SUFFIX = "/getPossibleDeliveryDatesSub";

export const SUBSCRIPTIONS_CUSTOMER_GET_POSSIBLE_DELIVERY_DATES_PATH = `${
  SUBSCRIPTION_CUSTOMER_DELIVERY_DATES_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_GET_POSSIBLE_DELIVERY_DATES_SUFFIX
}`;
